// Kanal konsumsi fuel dikelompokin per METODE ukur, bukan per nama engine yang
// ditulis tangan di template. Tiap kapal beda: GM07 ME-nya ber-flowmeter dan
// AE-nya konstanta, AWB Bayu kebalikannya. Lihat vault
// Architecture/fuel-consumption-dan-sumber-data.
import { parseNum } from '../number.js';

const ME_POSITIONS = ['PORT', 'STARBOARD', 'CENTER'];

// Nama group flowmeter posisi engine perlu diperjelas perannya; nama lain
// (AE4, AE_INLINE) udah jelas sendiri.
export function meRolePrefix(name) {
  return ME_POSITIONS.includes(String(name || '').toUpperCase()) ? 'Main Engine' : '';
}

// groups = deviceStatus.flowmeterGroups (BUNKER udah diexclude di store/asset).
// fmSummary = rawSummary.flowmeter.summary, angka mentah.
export function classifyFuelChannels({
  groups = [], fmSummary = {}, aeCons, aeHidden = false,
} = {}) {
  const measured = groups
    .map((g) => ({
      name: g.name,
      value: Number(fmSummary[`${String(g.name).toLowerCase()}EngineCons`]),
    }))
    .filter((c) => Number.isFinite(c.value));

  const calculated = [];
  const ae = parseNum(aeCons);
  if (!aeHidden && Number.isFinite(ae)) calculated.push({ name: 'AUXILIARY_ENGINE', value: ae });

  const sum = (rows) => rows.reduce((t, r) => t + r.value, 0);
  const measuredTotal = sum(measured);
  const calculatedTotal = sum(calculated);
  const total = measuredTotal + calculatedTotal;

  return {
    measured,
    calculated,
    measuredTotal,
    calculatedTotal,
    total,
    estimatePct: total ? (calculatedTotal / total) * 100 : 0,
  };
}
